<template>
    <div>
        <!-- Наименование вкладки -->
<!--        <vue-headful :title="$t('study_plan')" />-->
        <vx-card>
            <div   v-if="studentEducation" >
                <div class="mb-1" v-for="(key, index) in Object.keys(studentEducation)" :key="index">
                    <div v-if="key !== 'additional_profiles'"><b>{{ $t(key) }}:</b> {{ studentEducation[key] }} </div>
                </div>
                <div class="mt-4" v-if="studentEducation.additional_profiles.length > 0">
                    <div class="mb-1" v-for="(item, i) in  studentEducation.additional_profiles" :key="i">
                        <div><b>{{ item.study_plan_type }}:</b> {{ item.education_program_type }} </div>
                    </div>
                </div>

             </div>
        </vx-card>

    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {

    computed: {
        ...mapGetters({
            studentEducation: 'profile/getStudentEducation'
        })

    },
};
</script>

<style lang="scss">

</style>
